export default __webpack_public_path__ + "static/media/civics-bg.3bc7ec15.webp";